import axios from '@/services/api'

/**
 *
 * @returns {Promise<Object>}
 */
export const getResources = (queryParams) => {
	const url = `/api/resources?${queryParams}`
	return axios.get(url)
}

/**
 * @param {Number} categoryId
 *
 * @returns {Promise<Object>}
 */
export const getResource = (categoryId) => {
	const url = `/api/resources/${categoryId}`
	return axios.get(url)
}
